import React from 'react'
import SecondNavBar from '../../components/2nd_Navbar/SecondNavBar'
// import Footer from '../../components/Footer/Footer'

const JournalPage = () => {
  return (
    <div>
        <SecondNavBar/>
        <div className='journalpage'>
            body
        </div>
        {/* <Footer/> */}
    </div>
  )
}

export default JournalPage